import React, { useEffect } from 'react';
import CheckBox from 'components/CheckBox';
import TextField from 'components/TextField';
import { MainWrapper } from '../style';
import GoBackToPrev from '../../GoBackToPrev';
import StyledActiveButton from 'components/Button/StyledActiveButton';
import { useLocation } from 'react-router-dom';

const FillContactFormStep = ({
  formData,
  selectedMallData,
  setFormData,
  setStep,
  runAccountAuthProcess,
  setModalData,
  setShowModal,
}) => {
  const location = useLocation();
  // 데이터 연동 정보 수정 > 2차인증 정보 변경 > '직접 인증' 선택으로 진입한 케이스
  const isDirectContactStep = location?.state?.step === 'contactStep';

  const { secondAuthType, secondAuthValue } = formData;

  const {
    mallName = '',
    interlockOpenYn = '',
    secondAuthMethodEmailYn = '',
    secondAuthMethodSmsYn = '',
  } = selectedMallData;

  // 이전으로 돌아가기 버튼 클릭
  const onClickBackBtn = () => {
    setFormData({ ...formData, secondAuthType: '', secondAuthValue: '' });
    setStep('accountStep');
  };

  // 2차 인증 정보 입력
  const onChangeSecondAuthField = event => {
    const { value } = event.target;
    // SAT111: 문자 인증, SAT112: 이메일 인증
    const formatValue =
      secondAuthType === 'SAT111'
        ? value?.replace(/[^0-9]/g, '')
        : value?.replace(/\s+/g, '');
    setFormData({
      ...formData,
      secondAuthValue: formatValue,
    });
  };

  // 2차 인증 방식 변경
  const onChangeSecondAuthType = value => {
    setFormData({ ...formData, secondAuthType: value, secondAuthValue: '' });
  };

  // 버튼 활성화 검증
  const isDisabledBtn = () => {
    return !secondAuthType || !secondAuthValue;
  };

  // 다음 버튼 클릭
  const onClickNextBtn = () => {
    // 입력값(이메일 형식) 검증
    if (secondAuthType === 'SAT112' && !secondAuthValue?.includes('@')) {
      setShowModal(true);
      setModalData({
        contents: '이메일은 @까지 입력해 주세요.',
        onClickConfirmBtn: () => setShowModal(false),
        confirmBtnName: '확인',
      });
      return;
    }
    const goManagerStep = interlockOpenYn === 'N';
    if (goManagerStep) {
      setStep('managerStep');
    } else {
      runAccountAuthProcess();
    }
  };

  // 2차인증 수단 초기값 셋팅
  useEffect(() => {
    if (!secondAuthType) {
      if (secondAuthMethodSmsYn !== 'N' && secondAuthMethodEmailYn !== 'N') {
        setFormData({ ...formData, secondAuthType: 'SAT111' });
      } else {
        if (secondAuthMethodSmsYn === 'Y') {
          setFormData({ ...formData, secondAuthType: 'SAT111' });
        } else if (secondAuthMethodEmailYn === 'Y') {
          setFormData({ ...formData, secondAuthType: 'SAT112' });
        }
      }
    }
  }, [secondAuthType, secondAuthMethodSmsYn, secondAuthMethodEmailYn]);

  return (
    <MainWrapper>
      {!isDirectContactStep && <GoBackToPrev onClickReset={onClickBackBtn} />}
      <div className="contentsWrapper">
        <p className="title">
          2차 인증 수단을 입력해 주세요
          <br />
          <span>
            {`${mallName} 어드민에 등록된 휴대폰번호 또는 이메일을 입력해 주세요`}
          </span>
        </p>
        <section className="contactFormStepBox">
          <div>
            <CheckBox
              type="radio"
              name="secondAuthType"
              value="SAT111"
              text="문자 인증"
              id="SAT111"
              isChecked={secondAuthType === 'SAT111'}
              disabled={secondAuthMethodSmsYn === 'N'}
              onChangeCheckBox={() => onChangeSecondAuthType('SAT111')}
            />
            <CheckBox
              type="radio"
              name="secondAuthType"
              value="SAT112"
              id="SAT112"
              text="이메일 인증"
              isChecked={secondAuthType === 'SAT112'}
              disabled={secondAuthMethodEmailYn === 'N'}
              onChangeCheckBox={() => onChangeSecondAuthType('SAT112')}
            />
          </div>
          <TextField
            name="secondAuthValue"
            placeholder={
              secondAuthType === 'SAT111'
                ? '휴대폰번호(-제외)'
                : '이메일(@까지 입력)'
            }
            type="text"
            value={secondAuthValue || ''}
            onChange={onChangeSecondAuthField}
          />
        </section>
        <div className="nextBtnBox">
          <StyledActiveButton
            onClick={onClickNextBtn}
            disabled={isDisabledBtn()}
          >
            다음
          </StyledActiveButton>
        </div>
      </div>
    </MainWrapper>
  );
};

export default FillContactFormStep;
